import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  FETCH_CONNECTEDDEBTORS_FAILURE,
  FETCH_CONNECTEDDEBTORS_REQUEST,
  FETCH_CONNECTEDDEBTORS_SUCCESS
} from "../types";

const handleResponse = (
  response,
  dispatch,
  debtorProfile,
  id,
  limit,
  ordering,
  filters
) => {
  const data = normalize(response.results, [debtorProfile]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(FETCH_CONNECTEDDEBTORS_SUCCESS)({
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      limit,
      ordering,
      filters
    })
  );
  return response;
};

export const next = (id, link, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(FETCH_CONNECTEDDEBTORS_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.debtorProfile,
      id,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_CONNECTEDDEBTORS_FAILURE)(err));
    throw err;
  }
};

const queryConnectedDebtorsDebounced = debounce(
  async (dispatch, schema, api, factoringId, limit, ordering, filters) => {
    dispatch(
      createAction(FETCH_CONNECTEDDEBTORS_REQUEST)({
        id: factoringId,
        limit,
        ordering,
        filters
      })
    );
    const response = await api.debtors.queryConnectedDebtors(
      factoringId,
      ordering,
      limit,
      filters
    );
    return handleResponse(
      response,
      dispatch,
      schema.debtorProfile,
      factoringId,
      limit,
      ordering,
      filters
    );
  },
  1000,
  { trailing: true }
);

const queryConnectedDebtors = (
  factoringId,
  ordering,
  limit,
  filters = {}
) => async (dispatch, getState, { api, schema }) => {
  try {
    await queryConnectedDebtorsDebounced(
      dispatch,
      schema,
      api,
      factoringId,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_CONNECTEDDEBTORS_FAILURE)(err));
    throw err;
  }
};

export default queryConnectedDebtors;
